import React, { useState } from "react";

import ChatAccessNotice from "./ChatAccessNotice";
import VylorLogo from "components/VylorLogo";
import useChatAccess from "./useChatAccess";
import styles from "./AccessGate.module.scss";

interface AccessGateProps {
  children: React.ReactNode;
}

/**
 * Checks chat access before showing the app (ADR 077). Blocked users only see
 * the access notice. Users about to lose access see the warning first, and can
 * continue into the app.
 */
export default function AccessGate({ children }: AccessGateProps) {
  const access = useChatAccess();
  const [continued, setContinued] = useState(false);

  if (access === "allowed" || access === "unknown") return <>{children}</>;
  if (access === "warned" && continued) return <>{children}</>;

  return (
    <main className={styles.accessGate}>
      <div className={styles.content}>
        <div className={styles.logo}>
          <VylorLogo alt="Vylor" />
        </div>
        <ChatAccessNotice access={access}>
          {access === "warned" && (
            <button
              type="button"
              onClick={() => setContinued(true)}
              className={styles.continueButton}
            >
              Continue to Research Chat
            </button>
          )}
        </ChatAccessNotice>
      </div>
    </main>
  );
}
